import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { CalendarClock, CalendarRange, Clock, Users, Receipt, Beer, Package, ImageIcon, Sun, LogOut, Home, Type, KeyRound, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABELS } from "@/lib/api";

const BUTTONS = [
  { to: "/mind/reservas", icon: CalendarClock, title: "Reservas & Faturamento", perm: "reservas", color: "from-[#1B7A45] to-[#0E4325]" },
  { to: "/mind/agenda", icon: CalendarRange, title: "Agenda do mês", perm: "agenda", color: "from-[#2563eb] to-[#1e3a8a]" },
  { to: "/mind/usuarios", icon: Users, title: "Usuários", perm: "usuarios", color: "from-[#7c3aed] to-[#4c1d95]" },
  { to: "/mind/vendas", icon: Receipt, title: "Vendas do Bar", perm: "vendas", color: "from-[#C7962B] to-[#8a6615]" },
  { to: "/mind/produtos", icon: Beer, title: "Cadastro de Produtos", perm: "produtos", color: "from-[#E8611A] to-[#B8440E]" },
  { to: "/mind/estoque", icon: Package, title: "Estoque", perm: "estoque", color: "from-[#0891b2] to-[#155e75]" },
  { to: "/mind/horarios", icon: Clock, title: "Controle de Horários", perm: "horarios", color: "from-[#475569] to-[#1e293b]" },
  { to: "/mind/midia", icon: ImageIcon, title: "Logos, Imagens e Banners", perm: "midia", color: "from-[#db2777] to-[#831843]" },
  { to: "/mind/textos", icon: Type, title: "Textos das Páginas", perm: "textos", color: "from-[#0d9488] to-[#134e4a]" },
  { to: "/mind/dayuse", icon: Sun, title: "DayUse, Ranking e Jogos", perm: "dayuse", color: "from-[#ea580c] to-[#7c2d12]" },
  { to: "/mind/torneio", icon: Trophy, title: "Torneios", perm: "torneio", color: "from-[#ca8a04] to-[#713f12]" },
  { to: "/mind/permissoes", icon: KeyRound, title: "Permissões", owner: true, color: "from-[#111827] to-[#000000]" },
];

export default function AdminHome() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const buttons = BUTTONS.filter((b) => (b.owner ? user?.is_owner : (user?.perms || []).includes(b.perm)));

  return (
    <div className="min-h-screen bg-[#0b1610]" data-testid="admin-home">
      <div className="relative bg-gradient-to-br from-[#0b1610] via-[#123021] to-[#0b1610]">
        <div className="mx-auto max-w-4xl px-5 py-8">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-display text-2xl font-black text-white">Painel Dubal</p>
              <p className="text-sm text-emerald-100/60">{user?.is_owner ? "Proprietário" : ROLE_LABELS[user?.role] || "Administrador"} · {user?.email}</p>
            </div>
            <div className="flex gap-2">
              <button data-testid="admin-home-site" onClick={() => navigate("/")} className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur transition hover:bg-white/20"><Home className="h-4 w-4" /> Site</button>
              <Button variant="outline" size="sm" onClick={() => { navigate("/login"); logout(); }} data-testid="admin-home-logout" className="rounded-full border-white/20 bg-white/10 text-white hover:bg-white/20"><LogOut className="mr-1.5 h-4 w-4" /> Sair</Button>
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {buttons.map((b, i) => (
              <Link key={b.to} to={b.to} data-testid={`adminbtn-${b.to.split("/").pop()}`} style={{ animationDelay: `${i * 60}ms` }} className={`animate-fade-up flex flex-col gap-3 rounded-3xl bg-gradient-to-br ${b.color} p-6 shadow-xl transition hover:scale-[1.02]`}>
                <b.icon className="h-9 w-9 text-white/90" />
                <span className="font-display text-lg font-black leading-tight text-white">{b.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
